import axios from 'axios';

import { useQuery } from '@tanstack/react-query';

import type { IntervalComment } from '@optiro/types';

import { API_URL } from '@/lib/apiUrl';
import { queryKeys } from '@/lib/queryKeys';
import { Interval } from '@/types/types';

// Deliberately not useApi(): a 401/403 here (anonymous or non-partner viewer
// on a shared/cross-tenant Gantt) must surface as a query error the drawer
// can render a CTA for, not trigger useApi's global redirect-to-login.
const axiosInstance = axios.create({ baseURL: API_URL, withCredentials: true });

export const useIntervalComments = (intervalId: Interval['id']) => {
  return useQuery({
    queryKey: queryKeys.intervals.comments(intervalId).queryKey,
    queryFn: async () => {
      const { data } = await axiosInstance.get<IntervalComment[]>(
        `/api/v1/intervals/${intervalId}/comments`
      );
      return data;
    },
    enabled: !!intervalId,
    retry: false,
  });
};
